// extracted by mini-css-extract-plugin
export var icon = "menu-legend-module--icon--iKhKi";
export var legendEntry = "menu-legend-module--legend-entry--wJsL+";
export var legendTitle = "menu-legend-module--legend-title--bDyyf";
export var legendWrapper = "menu-legend-module--legend-wrapper--3zNO3";